export default __webpack_public_path__ + "static/media/Leggings of the Oxmal.53c577ff.jpg";